import apiHelper from '@/services/helper'

const getMenu = async (param) => {
    try {
        let url = '/admin/staff/permission'
        return (await apiHelper.getWithFirebaseToken(url, param)).data
    } catch (error) {
        return Promise.reject(error)
    }
}

export default {
    getMenu
}
